export	default {
    add: '添加',
    search_tips: '注意事项',
    booth_info: '1. 选择投保展位',
    boothNo: '展位号',
    boothNo_input: '请选择投保展位(可输入检索)',
    input_tips_first: '左侧输入框输入展位号，点击查询按钮，等待搜索出来后',
    input_tips_second: '点击结果即可选中，选中后会在下方显示。',
    input_tips_title: '如何选择展位',
    search: '查询',
    selected_booth: '已选展位',
    query_booth: '查询到以下展位',
    import_booth: '导入展位号',
    non_selection: '您还没有选择需要购买保险的展位',
    remove_confirm: '确定删除',
    remove_btn: '删除',
    non_search_booth: '未查询到您输入的展位号',
    company_info: '2. 填写公司信息',
    taxCode: '被保险公司统一社会信用代码',
    form_taxCode_check: '请输入正确的统一社会信用代码',
    form_taxCode_text: '请输入被保险公司统一社会信用代码',
    companyName: '被保险公司名称',
    form_companyName_check: '请输入被保险公司名称',
    contact_person_name: '联系人姓名',
    form_contactPerson_check: '请输入联系人姓名',
    phone: '电话',
    form_phone_check: '请输入正确的手机号码',
    form_phone_placeholder: '请输入联系人电话号码',
    email: '邮箱',
    form_email_check: '请输入正确的邮箱',
    form_email_placeholder: '请输入邮箱',
    user_info: '已有联系人',
    user_info_tips: '可直接勾选',
    goto_buy: '开始购买',
    select: '选择',
    booth_area: '展位面积',
    actions: '操作',
    net_error: '获取信息失败，请刷新重试',
    non_search_booth_tips: '该展会没有您所查询展位号，请检查展位号是否正确后重新输入',
    taxCode_tips_title: '提示信息',
    taxCode_tips: '发票税号/纳税识别号信息与公司名称不匹配，请确认是否输入正确。',
    competed_tips: '已完成购买？如没有保险购买界面，请',
    "点击此处":"点击此处",
    competed: '完成',
    carry_on: '继续购买',
    '展位类型':'展位类型',
    '参展商':'参展商',
    '参展商联系人':'参展商联系人',
    '电话':'电话',
    '邮箱':'邮箱',
    '传真':'传真',
    '备注':'备注',
	
	//1686ui优化
	'购买保险':'购买保险',
	'目前仅支持购买展会保（展览会责任险）;':'目前仅支持购买展会保（展览会责任险）;',
	'一次下单仅支持用一个公司购买保险;':'一次下单仅支持用一个公司购买保险;',
	'如您的展位面积包含小数，系统将会按整数计算（舍去小数位），不影响投保;':'如您的展位面积包含小数，系统将会按整数计算（舍去小数位），不影响投保;',
	'一次购买保险的展位数量最多不能超过5个，如有多个请分批购买;':'一次购买保险的展位数量最多不能超过5个，如有多个请分批购买;',
	'请务必保证填写信息的真实性和准确性，如因信息填写有误造成的后果由客户自行承担。':'请务必保证填写信息的真实性和准确性，如因信息填写有误造成的后果由客户自行承担。',
	'已选择':'已选择',
	'个展位，最多可选择':'个展位，最多可选择',
	'个展位':'个展位',
	'公司名称':'公司名称',
	'展位号':'展位号',
	'展位面积（㎡）':'展位面积（㎡）',
	'操作':'操作',
  '使用此联系人信息':'使用此联系人信息',
  '未查询到您输入的展位号，您可以':'未查询到您输入的展位号，您可以',
  '添加展位':'添加展位',
  '确定':'确定',
  '取消':'取消',

	'展会未配置保险承保方案':'展会未配置保险承保方案',
  

  }


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/insuranceHome.js